<app-nav ></app-nav>

<main role="main">
  <router-outlet></router-outlet>
</main>

<ng-http-loader
  [backgroundColor]="'#4FC3F7'"
  [spinner]="spinkit.skChasingDots"
  [debounceDelay]="100"
  [minDuration]="300"
  [extraDuration]="300"></ng-http-loader>
